<div class="borrower_container-big">
@if (creditData && infoBorrower && userData) {
<app-dni [disableChangeStatus]="true" [creditData]="creditData" [secondaryReason]="secondaryReason"
[infoBorrower]="infoBorrower" [cotitular]="cotitular" [idParam]="creditId" [financingCode]="financingCode"></app-dni>
}
</div>